<vue-chip [color]="chipColor">
  <ng-container *ngIf="status === 'inactive'">
    {{ 'label.inactive' | translate | async }}
  </ng-container>
  <ng-container *ngIf="status === 'active'">
    {{ 'label.active' | translate | async }}
  </ng-container>
</vue-chip>
